import React from 'react';
import Slider1 from './Slide1';
import Slider2 from './Slider2';
import Constant from '../../Constant';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import GroupIcon from '@mui/icons-material/Group';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SecurityIcon from '@mui/icons-material/Security';
import CloseIcon from '@mui/icons-material/Close';
import Googles from '../../Assets/images/ggp.svg';
import Apples from '../../Assets/images/aap.svg';
import Google from '../../Assets/images/gplay.svg';
import Apple from '../../Assets/images/appP.svg';
import { motion } from "framer-motion";

function Sustain() {
  const features = [
    {
      icon: <CloseIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'No Interest. No Guesswork',
    },
    {
      icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Shariah-Compliant Investments',
    },
    {
      icon: <GroupIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Collaborative Wealth Building',
    },
    {
      icon: <VisibilityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Fairness and Transparency',
    },
    {
      icon: <SecurityIcon fontSize="medium" style={{ color: '#8046F2' }} />,
      text: 'Regulated and Secured',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <div className="bg-primary-color5 mt-20 p-6 md:p-24">
      <div className="md:hidden block">
        <Slider2 />
      </div>

      <div className="grid mb-8 md:mb-16 md:grid-cols-2 gap-5">
        <div className="md:flex md:flex-col justify-center hidden">
          <Slider2 />
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="flex flex-col justify-center"
        >
          <motion.h1
            variants={item}
            className="font-normal text-text-color1 md:text-[44px] mb-4 text-[24px]"
          >
            Halal Wealth
            <span className={Constant.linearColor}> and Ethical Principle</span>
          </motion.h1>

          <motion.p
            variants={item}
            className="font-normal text-text-color1 md:text-[18px] mb-4 text-[14px]"
          >
            Forget the gimmicks. Halal Wealth blends ethical finance with cutting-edge technology and a community-first approach. Unlike conventional savings apps, you can choose to invest your Individual and collective capital in halal sectors - with full transparency and rewards tied to real performance.
          </motion.p>

          <motion.ul
            variants={container}
            className="mt-4 space-y-3"
          >
            {features.map((feature, index) => (
              <motion.li key={index} variants={item} className="flex items-center gap-3">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: '#F5F1FE' }}
                >
                  {feature.icon}
                </div>
                <span className="text-[14px] md:text-[16px] font-[400] text-text-color1">
                  {feature.text}
                </span>
              </motion.li>
            ))}
          </motion.ul>
        </motion.div>
      </div>

      <div className="grid mt-8 md:grid-cols-2 gap-6">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={container}
          className="flex flex-col justify-center"
        >
          <motion.h1
            variants={item}
            className="font-normal text-text-color1 md:text-[44px] mb-4 text-[24px]"
          >
            Built for Web and Mobile
          </motion.h1>

          <motion.p
            variants={item}
            className="font-normal text-text-color1 md:text-[18px] mb-4 text-[14px]"
          >
            Initiate seamless transactions on any device wherever you are.
          </motion.p>

          <motion.div variants={item} className="sm:flex gap-5">
            <img src={Google} className="hidden sm:block" alt="Google play store" />
            <img src={Apple} className="hidden sm:block" alt="Apple app store" />
            <img src={Googles} className="block mb-3 sm:mb-0 mx-auto sm:hidden" alt="Google play store" />
            <img src={Apples} className="block mx-auto sm:hidden" alt="Apple app store" />
          </motion.div>
        </motion.div>

        <div className="md:flex md:flex-col justify-center hidden">
          <Slider1 />
        </div>
      </div>

      <div className="mt-5 md:hidden block">
        <Slider1 />
      </div>
    </div>
  );
}

export default Sustain;
